import axios from "axios"
import React, {Component} from "react"
import { withRouter } from "react-router-dom"
import ApiHelper from "src/ApiHelper"
import "bootstrap/dist/css/bootstrap.min.css"
import DeveloperPortalCompaniesRow from "src/components/table/DeveloperPortalCompaniesRow"
import DeveloperPortalUnidentifiedCompaniesRow from "src/components/table/DeveloperPortalUnidentifiedCompaniesRow"
import DeveloperPortalCompanySearchResults from "src/components/table/DeveloperPortalCompanySearchResults"
class DeveloperPortalCompanies extends Component{
    constructor(props){
        console.log("Brokerage")
        super(props)
        this.state = {
            companylistoffset: 0,
            companysearchresults: "",
            alphavantagesearchresults: [],
            alphavantagesearchloading: false,
            companieslist: [],
            companiescount: 0,
            unidentifiedcompanylistoffset: 0,
            unidentifiedcompanylist: [],
            unidentifiedcompanycount: 0,
            addcompanyform: {
                company: "",
                description: "",
                symbol: "",
                searchkey: "",
                errormessage: ""
            },
            updatecompanyform: {
                serialid: "",
                company: "",
                description: "",
                symbol: "",
                searchkey: "",
                errormessage: ""
            },
            removecompanyform: {
                companyid: "",
                errormessage: ""
            },
            searchalphavantagesymbolform: {
                keyword: "",
                errormessage: ""
            },
            companydetails: {
                serial_id: "",
                company: "",
                description: "",
                symbol: "",
                searchkey: "",
                relevance: 0,
                lastchecked: 0,
                arthscore: "",
                targetdifference: "",
                dailyhistory:[],
                recommendationid: "",
                action: "",
                targetprice: "",
                recommender: "",
                timestamp: 0,
                noofrecommendations: ""
            }
        }
    }
    showCompanySearchResults(){
        return this.state.companysearchresults
    }
    showAlphaSearchResults(){
        var rows = []
        for(var i = 0; i < this.state.alphavantagesearchresults.length; i++){
            var result = this.state.alphavantagesearchresults[i]
            rows.push(<DeveloperPortalCompanySearchResults addCompany={this.addCompanyFromAlphaVantageResults.bind(this)} key={i} name={result.name} type={result.type} region={result.region} currency={result.currency} symbol={result.symbol}/>)
        }
        return rows
    }
    showCompanyDetails(){
        if(this.state.companydetails.serial_id.length === 0){
            return <div></div>
        }
        var dailyhistory = JSON.parse(this.state.companydetails.dailyhistory)
        dailyhistory = dailyhistory.map(single => {
            single = Object.values(single)
            return <div>
                Date: {single[0]} Volume: {single[5]}<br/>
                Open: {single[1]} High: {single[2]} Low: {single[3]} Close: {single[4]}<br/> 
            </div>
        })
        var reldt = new Date(this.state.companydetails.relevance * 1000)
        var lcdt = new Date(this.state.companydetails.lastchecked * 1000)
        var recdt = this.state.companydetails.relevance !== 0? new Date(this.state.companydetails.timestamp * 1000): null
        return <div className="c_companydetails">
            <b>Serial ID:</b> {this.state.companydetails.serial_id}<br/>
            <b>Company:</b> {this.state.companydetails.company}<br/>
            <b>Description:</b> {this.state.companydetails.description}<br/>
            <b>Symbol:</b> {this.state.companydetails.symbol}<br/>
            <b>Search Key:</b> {this.state.companydetails.searchkey}<br/>
            <b>Relevance:</b> {reldt.getHours() + ":" + reldt.getMinutes() + " On " + reldt.getDate() + "/" + reldt.getMonth() + 1}<br/>
            <b>Last Checked:</b> {lcdt.getHours() + ":" + lcdt.getMinutes() + " On " + lcdt.getDate() + "/" + lcdt.getMonth() + 1}<br/>
            <b>ArthScore:</b> {this.state.companydetails.arthscore}<br/>
            <b>Target Difference:</b> {this.state.companydetails.targetdifference}<br/>
            <b>Target Price:</b> {this.state.companydetails.targetprice}<br/>
            <b>Latest Recommendation ID:</b> {this.state.companydetails.serial_id}<br/>
            <b>Action:</b> {this.state.companydetails.serial_id}<br/>
            <b>Target Price:</b> {this.state.companydetails.serial_id}<br/>
            <b>Recommender:</b> {this.state.companydetails.serial_id}<br/>
            <b>Recommended On:</b> {recdt === null?"": recdt.getHours() + ":" + recdt.getMinutes() + " On " + recdt.getDate() + "/" + recdt.getMonth() + 1}<br/>
            <b>Total Recommendations:</b> {this.state.companydetails.serial_id}<br/>
            <b>Daily History:</b> {dailyhistory}<br/>
            <button className="c_developerportal_buttononwhite" onClick={this.setUpdateForm.bind(this)}>Edit</button>
        </div>
    }
    setUpdateForm(){
        const newstate = {...this.state}
        const companydetails = {...this.state.companydetails}
        newstate.updatecompanyform = {
            serialid: companydetails.serial_id,
            company: companydetails.company,
            description: companydetails.description,
            symbol: companydetails.symbol,
            searchkey: companydetails.searchkey,
            errormessage: ""
        }
        this.setState(newstate, () => {
            alert("Check The Update Form")
        })
    }
    showCompanyList(){
        var companylist = []
        for(var i = 0; i < this.state.companieslist.length; i++){
            var company = this.state.companieslist[i]
            companylist.push(<DeveloperPortalCompaniesRow key={company.serial_id} getDetails={this.getCompanySpecific.bind(this)} serialid={company.serial_id} company={company.company} description={company.description} symbol={company.symbol} searchkey={company.searchkey}/>)
        }
        return <React.Fragment>
            {companylist}
        </React.Fragment>
    }
    showUnidentifiedCompanyList(){
        var companylist = []
        for(var i = 0; i < this.state.unidentifiedcompanylist.length; i++){
            var company = this.state.unidentifiedcompanylist[i]
            companylist.push(<DeveloperPortalUnidentifiedCompaniesRow key={company.serial_id} getDetails={this.getCompanySpecific.bind(this)} serialid={company.serial_id} company={company.company} timestamp={company.timestamp}/>)
        }
        return <React.Fragment>
            {companylist}
        </React.Fragment>
    }
    render(){
        return <div className="c_developerportal_content">
            <h4>Search Company Symbol ( AlphaVantage )</h4>
            <input name="keyword" className="c_developerportal_inputonwhite" onChange={this.searchAlphaVantageSymbolChangeHandler.bind(this)} placeholder="Keyword"/>
            <button onClick={this.searchAlphaVantageSymbol.bind(this)} className="c_developerportal_buttononwhite">Search</button>
            <div className="c_developerportal_searchresults">
                {this.state.alphavantagesearchloading?<p>Loading</p>:<p></p>}
                {this.showAlphaSearchResults()}
            </div>
            <hr/>
            <h4>Add Company</h4>
            <input name="company" className="c_developerportal_inputonwhite" onChange={this.addCompanyChangeHandler.bind(this)} value={this.state.addcompanyform.company} placeholder="Title(AlphaVantage)"/>
            <input name="description" className="c_developerportal_inputonwhite" onChange={this.addCompanyChangeHandler.bind(this)} value={this.state.addcompanyform.description} placeholder="Description"/><br/>
            <input name="symbol" className="c_developerportal_inputonwhite" onChange={this.addCompanyChangeHandler.bind(this)} value={this.state.addcompanyform.symbol} placeholder="Symbol"/>
            <input name="searchkey" className="c_developerportal_inputonwhite" onChange={this.addCompanyChangeHandler.bind(this)} value={this.state.addcompanyform.searchkey} placeholder="Title(Recommendations)"/><br/>
            <button onClick={this.addCompany.bind(this)} className="c_developerportal_buttononwhite">Submit</button>
            <p>{this.state.addcompanyform.errormessage}</p>
            <hr/>
            <h4>List Of Unidentified Companies</h4>
            <h6>Showing {this.state.unidentifiedcompanylistoffset} - {this.state.unidentifiedcompanylistoffset + this.state.unidentifiedcompanylist.length} of {this.state.unidentifiedcompanycount} companies</h6>
            <p className="text-danger"></p>
            <div className="c_developerportal_searchresults">
                <div className="row">
                    <div className="col-md-2">ID</div>
                    <div className="col-md-10">Name</div>
                </div>
                {this.showUnidentifiedCompanyList()}
                <button className="c_developerportal_buttononwhite" onClick={this.deleteAllUnidentifiedCompanies.bind(this)}>Delete All</button>
            </div>
            <h4>Remove Company</h4>
            <input name="companyid" className="c_developerportal_inputonwhite" onChange={this.removeCompanyChangeHandler.bind(this)} placeholder="Serial ID"/>
            <button onClick={this.removeCompany.bind(this)}className="c_developerportal_buttononwhite">Submit</button>
            <p>{this.state.removecompanyform.errormessage}</p>
            <hr/>
            <h4>List Of Companies</h4>
            <h6>Showing {this.state.companylistoffset} - {this.state.companylistoffset + this.state.companieslist.length} of {this.state.companiescount} companies</h6>
            <p className="text-danger"></p>
            <div className="c_developerportal_searchresults">
                <div className="row">
                    <div className="col-md-2">ID</div>
                    <div className="col-md-10">Name</div>
                </div>
                {this.showCompanyList()}
            </div>
            <button className="c_developerportal_buttononwhite" onClick={this.decrementOffset.bind(this)}>Prev</button>
            <button className="c_developerportal_buttononwhite" onClick={this.incrementOffset.bind(this)}>Next</button>
            <hr/>
            <h4>Update Company</h4>
            Serial ID:<br/><input name="serialid" className="c_developerportal_inputonwhite" value={this.state.updatecompanyform.serialid} placeholder="Serial ID" readOnly/><br/>
            Company: <br/><input name="company" className="c_developerportal_inputonwhite" onChange={this.updateCompanyHandler.bind(this)} value={this.state.updatecompanyform.company} placeholder="Company(AlphaVantage)"/><br/>
            Description: <br/><input name="description" className="c_developerportal_inputonwhite" onChange={this.updateCompanyHandler.bind(this)} value={this.state.updatecompanyform.description} placeholder="Description"/><br/>
            Search Key: <br/><input name="searchkey" className="c_developerportal_inputonwhite" onChange={this.updateCompanyHandler.bind(this)} value={this.state.updatecompanyform.searchkey} placeholder="Title(Recommendations)"/><br/>
            Symbol: <br/><input name="symbol" className="c_developerportal_inputonwhite" onChange={this.updateCompanyHandler.bind(this)} value={this.state.updatecompanyform.symbol} placeholder="Symbol"/><br/>
            <button onClick={this.onUpdateClicked.bind(this)}className="c_developerportal_buttononwhite">Submit</button>
            <p>{this.state.updatecompanyform.errormessage}</p>
            <hr/>
            <h4>Details(click on details in the company list)</h4>
            {this.showCompanyDetails()}
            <hr/>
            <hr/>
        </div>
    }
    deleteAllUnidentifiedCompanies(){
        var deleteall = axios.post(ApiHelper.brokerRecos.deleteAllUnidentifiedCompanies)
        deleteall.then(response => {
            alert(response.data.error_message)
            this.getUnidentifiedCompanyList()
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    getCompanySpecific(serialid){
        var companyspecific = axios.post(ApiHelper.companies.getCompanySpecific, {serialid})
        companyspecific.then(response => {
            const newstate = {...this.state}
            const data = response.data.data[0]
            newstate.companydetails = {
                serial_id: data.serial_id,
                company: data.company,
                description: unescape(data.description),
                symbol: data.symbol,
                searchkey: data.searchkey,
                relevance: data.relevance,
                lastchecked: data.lastchecked,
                arthscore: data.arthscore.toFixed(3),
                targetdifference: data.targetdifference,
                dailyhistory: data.dailyhistory,
                recommendationid: data.recommendationid,
                action: data.action,
                targetprice: data.targetprice,
                recommender: data.recommender,
                timestamp: data.timestamp,
                noofrecommendations: data.noofrecommendations
            }
            this.setState(newstate)
        }, error => {
            alert(error.response === undefined ? "An Error Occured" : error.response.error_message)
        })
    }
    onUpdateClicked(){
        var updatecompany = axios.post(ApiHelper.companies.updateCompany, {companyid: this.state.updatecompanyform.serialid, company: this.state.updatecompanyform.company, description: this.state.updatecompanyform.description, searchkey: this.state.updatecompanyform.searchkey, symbol: this.state.updatecompanyform.symbol})
        updatecompany.then(response => {
            alert(response.data.error_message)
        }, error => {
            alert(error.response === undefined ? "An Error Occured" : error.response.error_message)
        })
    }
    updateCompanyHandler(event){
        const newstate = {...this.state}
        newstate.updatecompanyform[event.target.name] = event.target.value
        this.setState(newstate)
    }
    addCompanyFromAlphaVantageResults(data){
        const newstate = {...this.state}
        newstate.addcompanyform.company = data.name
        newstate.addcompanyform.symbol = data.symbol
        this.setState(newstate)
    }
    addCompanyChangeHandler(event){
        const newstate = {...this.state}
        newstate.addcompanyform[event.target.name] = event.target.value
        this.setState(newstate)
    }
    removeCompanyChangeHandler(event){
        const newstate = {...this.state}
        newstate.removecompanyform[event.target.name] = event.target.value
        this.setState(newstate)
    }
    searchAlphaVantageSymbolChangeHandler(event){
        const newstate = {...this.state}
        newstate.searchalphavantagesymbolform[event.target.name] = event.target.value
        this.setState(newstate)
    }
    searchAlphaVantageSymbol(){
        const newstate = {...this.state}
        newstate.alphavantagesearchloading = true
        this.setState(newstate)
        var searchalphavantagesymbol = axios.post(ApiHelper.alphaVantage.searchSymbol, this.state.searchalphavantagesymbolform, ApiHelper.getAccessTokenHeaderConfig())
        searchalphavantagesymbol.then((response) => {
            const newstate = {...this.state}
            newstate.searchalphavantagesymbolform.keyword = ""
            newstate.searchalphavantagesymbolform.errormessage = response.data.error_message
            newstate.alphavantagesearchresults = response.data.data
            newstate.alphavantagesearchloading = false
            this.setState(newstate)
            this.resetOffset()
        }, (error) => {
            alert(error.response.data.error_message)
            const newstate = {...this.state}
            newstate.alphavantagesearchloading = false
            this.setState(newstate)
        })
    }
    componentWillUnmount(){
        
    }
    addCompany(){
        //console.log(this.state.addcompanyform)
        var addcompany = axios.post(ApiHelper.companies.addCompany, this.state.addcompanyform, ApiHelper.getAccessTokenHeaderConfig())
        addcompany.then((response) => {
            const newstate = {...this.state}
            newstate.addcompanyform.company = ""
            newstate.addcompanyform.description = ""
            newstate.addcompanyform.symbol = ""
            newstate.addcompanyform.searchkey = ""
            newstate.addcompanyform.errormessage = response.data.error_message
            this.setState(newstate)
            this.resetOffset()
        }, (error) => {
            const newstate = {...this.state}
            newstate.addcompanyform.errormessage = error.response.data.error_message
            this.setState(newstate)
        })
    }
    removeCompany(){
        var addcompany = axios.post(ApiHelper.companies.removeCompany, this.state.removecompanyform, ApiHelper.getAccessTokenHeaderConfig())
        addcompany.then((response) => {
            const newstate = {...this.state}
            newstate.removecompanyform.companyid = ""
            newstate.removecompanyform.errormessage = response.data.error_message
            this.setState(newstate)
            this.resetOffset()
        }, (error) => {
            const newstate = {...this.state}
            newstate.removecompanyform.errormessage = error.response.data.error_message
            this.setState(newstate)
        })
    }
    resetOffset(){
        const newstate = {...this.state}
        newstate.companylistoffset -= this.state.companylistoffset - 10 >= 0 ? 10: 0
        this.setState(newstate)
        this.getCompaniesCount()
        this.getCompaniesList()
    }
    decrementOffset(event){
        const newstate = {...this.state}
        newstate.companylistoffset -= this.state.companylistoffset - 10 >= 0 ? 10: 0
        this.setState(newstate, () => {
            this.getCompaniesList()
        })
    }
    incrementOffset(event){
        const newstate = {...this.state}
        newstate.companylistoffset += this.state.companylistoffset + 10 > this.state.companiescount ? 0: 10
        this.setState(newstate, () => {
            this.getCompaniesList()
        })
    }
    componentDidMount(){
        this.props.setLoading(false)
        this.getCompaniesList()
        this.getCompaniesCount()
        this.getUnidentifiedCompanyList()
        this.getUnidentifiedCompanyCount()
    }
    getUnidentifiedCompanyList(){
        var companieslist = axios.post(ApiHelper.brokerRecos.getUnidentifiedCompaniesByOffset, {offset: this.state.companylistoffset},ApiHelper.getAccessTokenHeaderConfig())
        companieslist.then((response) => {
            const newstate = {...this.state}
            console.log(response.data)
            newstate.unidentifiedcompanylist = response.data.data
            this.setState(newstate)
        }, (error) => {
            console.log(error)
        })
    }
    getUnidentifiedCompanyCount(){
        var companiescount = axios.post(ApiHelper.companies.getCompaniesCount, {} ,ApiHelper.getAccessTokenHeaderConfig())
        companiescount.then((response) => {
            // console.log(response)
            const newstate = {...this.state}
            newstate.unidentifiedcompanycount = response.data.data.noofcompanies
            this.setState(newstate)
        }, (error) => {
            console.log(error)
        })
    }
    getCompaniesList(){
        var companieslist = axios.post(ApiHelper.companies.getCompaniesByOffset, {offset: this.state.companylistoffset},ApiHelper.getAccessTokenHeaderConfig())
        companieslist.then((response) => {
            const newstate = {...this.state}
            newstate.companieslist = response.data.data
            this.setState(newstate)
        }, (error) => {
            console.log(error)
        })
    }
    getCompaniesCount(){
        var companiescount = axios.post(ApiHelper.companies.getCompaniesCount, {} ,ApiHelper.getAccessTokenHeaderConfig())
        companiescount.then((response) => {
            // console.log(response)
            const newstate = {...this.state}
            newstate.companiescount = response.data.data.noofcompanies
            this.setState(newstate)
        }, (error) => {
            console.log(error)
        })
    }
}
export default withRouter(DeveloperPortalCompanies)